import React from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate, useLocation, useParams } from 'react-router-dom'

import { isLocaleSupported } from '@probatix/common/utils/data'

import { privateLandingPage, publicLandingPage } from '@probatix/myprobatix/constants/page'
import useAuth from '@probatix/myprobatix/hooks/useAuth'

const RedirectContainer = () => {
  const { i18n } = useTranslation()
  const { locale } = useParams()
  const { pathname, search } = useLocation()
  const { isAuthenticated } = useAuth()

  if (!isLocaleSupported(locale)) {
    return <Navigate to={`/${i18n.language}${pathname}${search}`} />
  }

  if (isAuthenticated()) {
    return <Navigate to={`/${locale}/${privateLandingPage}`} />
  }

  return <Navigate to={`/${locale}/${publicLandingPage}`} />
}

export default RedirectContainer
